import { NameDto } from '../../Common/Types'

export interface PaymentAgentDto {
  name: string | null
  client: { name: string | null; id: string }
  description: string | null
  website: string | null
  singleTransactionLimit: number
  dailyTransactionLimit: number
  todaysTransaction: number
  powerOfAttorneyEmail: string | null
  withdrawalEmail: string | null
  powerOfAttorneyUrl: string | null
  introducingBrokerFundingType: NameDto
  isActive: boolean
  profiles: PaymentAgentProfileDto[]
  id: string
  selected?: boolean
}

export interface PaymentAgentProfileDto {
  firstName: string | null
  lastName: string | null
  email: string | null
  id: string | null
  phone: string | null
  socialMedia: PaymentAgentSocialMedia[]
}

export interface UpdatePaymentAgentProfileDto {
  firstName: string | null
  lastName: string | null
  email: string | null
  id: string | null
  phone: string | null
  socialMedia: { typeId: number; value: string }[]
}

export enum PaymentAgentKey {
  id = 'id',
  name = 'name',
  client = 'client.name',
  description = 'description',
  website = 'website',
  singleTransactionLimit = 'singleTransactionLimit',
  dailyTransactionLimit = 'dailyTransactionLimit',
  todaysTransaction = 'todaysTransaction',
  powerOfAttorneyEmail = 'powerOfAttorneyEmail',
  withdrawalEmail = 'withdrawalEmail',
  isActive = 'isActive',
  profiles = 'profiles',
}

export interface PaymentAgentSocialMedia {
  id: string
  socialMediaType: NameDto
  value: string
}

export enum PaymentAgentFilterKey {
  client = 'ClientId',
  name = 'Name',
  profileFirstName = 'Profile.FirstName',
  profileFullName = 'Profile.FullName',
  profileLastName = 'Profile.LastName',
  IsActive = 'IsActive',
  PowerOfAttorneyEmail = 'PowerOfAttorneyEmail',
}

export const IntroducingBrokerFundingTypes = [
  { name: 'Disabled', id: 10 },
  { name: 'Main IB', id: 20 },
  { name: 'Trading Account IB', id: 30 },
  { name: 'All Ib Options', id: 40 },
]
